/**
 * Wheel Themes Configuration
 * wheel.expert - Premium Wheel Color Themes
 * 
 * Each theme includes:
 * - id: unique identifier
 * - name: display name
 * - colors: array of 6-12 colors that cycle on the wheel
 * - textColor: color for text on slices
 * - preview: first 4 colors for UI preview
 */

export const WHEEL_THEMES = {
  default: {
    id: 'default',
    name: 'Default',
    nameKey: 'themes.default',
    colors: [
      '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7',
      '#DDA0DD', '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E9',
      '#F8B500', '#00D4AA', '#FF8C42', '#6C5CE7', '#A8E6CF'
    ],
    textColor: '#FFFFFF'
  },
  pastel: {
    id: 'pastel',
    name: 'Pastel Dreams',
    nameKey: 'themes.pastel',
    colors: [
      '#FFB5BA', '#FFDAC1', '#FCF4A3', '#C1E1C5', '#C4E5F5',
      '#E1C4F5', '#F5C4E4', '#C4F5E9', '#F5E1C4', '#C4D5F5',
      '#D5F5C4', '#F5C4C4'
    ],
    textColor: '#2D3748'
  },
  neon: {
    id: 'neon',
    name: 'Neon Glow',
    nameKey: 'themes.neon',
    colors: [
      '#FF00FF', '#00FFFF', '#FF0080', '#80FF00', '#FFFF00',
      '#00FF80', '#FF8000', '#8000FF', '#00FF00', '#FF0000',
      '#0080FF', '#FF00AA'
    ],
    textColor: '#FFFFFF'
  },
  ocean: {
    id: 'ocean',
    name: 'Ocean Breeze',
    nameKey: 'themes.ocean',
    colors: [
      '#006994', '#40E0D0', '#4682B4', '#5F9EA0', '#48D1CC',
      '#00CED1', '#20B2AA', '#008B8B', '#0077B6', '#00A8CC',
      '#3498DB', '#1ABC9C'
    ],
    textColor: '#FFFFFF'
  },
  sunset: {
    id: 'sunset',
    name: 'Sunset Vibes',
    nameKey: 'themes.sunset',
    colors: [
      '#FF6B6B', '#FFA07A', '#FFD93D', '#FF8E53', '#F97B22',
      '#EE5A24', '#FFC300', '#FF5733', '#C70039', '#FF7F50',
      '#FF4500', '#FF6347'
    ],
    textColor: '#FFFFFF'
  },
  forest: {
    id: 'forest',
    name: 'Forest Nature',
    nameKey: 'themes.forest',
    colors: [
      '#228B22', '#32CD32', '#6B8E23', '#8FBC8F', '#90EE90',
      '#2E8B57', '#3CB371', '#556B2F', '#9ACD32', '#7CFC00',
      '#00FA9A', '#66CDAA'
    ],
    textColor: '#FFFFFF'
  },
  monochrome: {
    id: 'monochrome',
    name: 'Monochrome',
    nameKey: 'themes.monochrome',
    colors: [
      '#2D3748', '#4A5568', '#718096', '#A0AEC0', '#CBD5E0',
      '#1A202C', '#4A5568', '#718096', '#A0AEC0', '#E2E8F0'
    ],
    textColor: '#FFFFFF'
  },
  rainbow: {
    id: 'rainbow',
    name: 'Classic Rainbow',
    nameKey: 'themes.rainbow',
    colors: [
      '#FF0000', '#FF7F00', '#FFFF00', '#00FF00', '#0000FF',
      '#4B0082', '#8F00FF', '#FF1493', '#FF4500', '#32CD32',
      '#00CED1', '#9400D3'
    ],
    textColor: '#FFFFFF'
  },
  candy: {
    id: 'candy',
    name: 'Candy Pop',
    nameKey: 'themes.candy',
    colors: [
      '#FF69B4', '#FF1493', '#DB7093', '#FFB6C1', '#FFC0CB',
      '#DA70D6', '#BA55D3', '#9370DB', '#FF00FF', '#EE82EE',
      '#DDA0DD', '#FF69B4'
    ],
    textColor: '#FFFFFF'
  },
  business: {
    id: 'business',
    name: 'Professional',
    nameKey: 'themes.business',
    colors: [
      '#2C3E50', '#3498DB', '#1ABC9C', '#34495E', '#2980B9',
      '#16A085', '#2C3E50', '#3498DB', '#1ABC9C', '#34495E'
    ],
    textColor: '#FFFFFF'
  },
  retro: {
    id: 'retro',
    name: 'Retro 80s',
    nameKey: 'themes.retro',
    colors: [
      '#FF6EC7', '#7DF9FF', '#FF5F1F', '#39FF14', '#FF073A',
      '#CCFF00', '#BF00FF', '#00FFFF', '#FF00FF', '#FFFF00',
      '#FF3F00', '#00FF00'
    ],
    textColor: '#FFFFFF'
  },
  christmas: {
    id: 'christmas',
    name: 'Christmas',
    nameKey: 'themes.christmas',
    colors: [
      '#C41E3A', '#228B22', '#FFD700', '#C41E3A', '#228B22',
      '#FFD700', '#C41E3A', '#228B22', '#FFD700', '#C41E3A'
    ],
    textColor: '#FFFFFF'
  }
};

// Get theme by ID with fallback
export const getTheme = (themeId) => {
  return WHEEL_THEMES[themeId] || WHEEL_THEMES.default;
};

// Get all themes as array for UI
export const getAllThemes = () => {
  return Object.values(WHEEL_THEMES);
};

// Get theme colors
export const getThemeColors = (themeId) => {
  const theme = getTheme(themeId);
  return theme.colors;
};

export default WHEEL_THEMES;
